import httpClient from 'utils/httpClient';

let pendingRegistration = null;
export const getUnreadNotificationCount = () => httpClient.get('/notify/unread-count');
export const getNewNotifications = afterId => httpClient.get('/notify', { params: { after_notify_user_id:afterId,itemsPerPage:100 } });
export const getNotificationPushConfig = () => httpClient.get('/notify/push-config');
export const registerNotificationDevice = payload => {
  const request = httpClient.post('/notify/devices', payload, { timeout: 20000 });
  pendingRegistration = request;
  request.finally(() => { if (pendingRegistration === request) pendingRegistration = null; }).catch(() => {});
  return request;
};
export const unregisterNotificationDevice = async deviceId => {
  if (pendingRegistration) await pendingRegistration.catch(() => {});
  return httpClient.delete('/notify/devices', { data: { device_id: deviceId }, timeout: 20000 });
};
